/* ─────────────────────────────────────────────────────────
   Wave section breaks - slight irregular waves between home
   sections. Shared by site.jsx and the lazy-loaded Page*.jsx
   files - its own module so neither side has a circular import
   on the other.
   ───────────────────────────────────────────────────────── */
const WAVE_PATHS = {
  ripple: 'M0,0 L1440,0 L1440,30 C1320,44 1180,18 1040,32 C880,48 760,20 600,34 C460,46 320,22 180,34 C100,41 40,30 0,36 Z',
  dune: 'M0,0 L1440,0 L1440,18 C1180,52 880,8 600,40 C380,62 160,24 0,44 Z',
  tide: 'M0,0 L1440,0 L1440,36 C1340,12 1240,54 1120,30 C980,4 880,52 740,34 C600,16 500,50 360,28 C240,10 120,46 0,30 Z'
};
export const WaveBreak = ({ fill = 'var(--surface-canvas)', flip = false, edge = '' }) =>
<div className={'wave-break' + (flip ? ' wave-break--flip' : '') + (edge ? ' wave-break--' + edge : '')} aria-hidden="true">
    <div className="wb-track">
      {/* The dune curve is the brand's section break. Render it directly so the
          page breaks are always the dune shape, with no dependency on the
          design-time html[data-wave] tweak (ripple/tide were editor-only). */}
      <svg className="wb-fill w-dune" viewBox="0 0 1440 56" preserveAspectRatio="none">
        <path d={WAVE_PATHS.dune} fill={fill}></path>
      </svg>
    </div>
  </div>;
